import { AppContext } from "@/App.context";
import config from "@/config";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";

/**
 * @typedef GetAllStatistics
 * @property {string} filter
 * @property {GetDataStatistics} data
 */

/**
 * @typedef GetDataStatistics
 * @property {string} id
 */

/**
 * @typedef GetAllStatisticsRes
 * @property {GetAllStatistics[]} statistics
 */

/**
/**
 * @typedef GetAccountStatisticsReq
 * @property {'aws' | 'gcp' | 'azure'} service
 *  @property {string } selectedTittle
 */

export const getAccountRegionStatistics = (token) => {
    /**
   * @param {GetAccountStatisticsReq} req
   * @param {AbortSignal=} signal
   * @returns {Promise<GetAllStatistics>}
   */
  return async ({ service,selectedTittle }, signal) => {
    const owners = await fetch(
      `${config.apiHost}/v1/${service}/savings/filter?type=${selectedTittle}`,
      {
        method: "GET",
        signal,
        headers: {
          Authorization: token,
        }
      }
    );
    if (!owners.ok) {
      throw new Error((await owners.json()).message);
    }
    return await owners.json();
  };
}

/**

 * @param {GetAccountStatisticsReq} req
 * @param {any[]=} deps
 */
export const useAccountRegionStatistics = (req, deps = []) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["getAccountRegionStatistics", req, ...deps],
    queryFn: ({ signal }) => getAccountRegionStatistics(appContext.idToken)(req, signal),
    enabled: req.selectedTittle != null
  });
  return query;
};
